import type { SnippetDetail, SnippetVersion } from './KnowledgeSnippet.model';
import { SnippetStatus } from './KnowledgeSnippet.model';

/**
 * Helper function to get the active version from a snippet detail
 * Returns the latest verified version, or the most recently updated version if no verified version exists
 */
export function getActiveVersion(snippet: SnippetDetail | null | undefined): SnippetVersion | null {
  if (!snippet || !snippet.versions || snippet.versions.length === 0) {
    return null;
  }

  const draftVersions = snippet.versions.filter(
    (v) => v.status === SnippetStatus.DRAFT
  );

  if (draftVersions.length > 0) {
    return draftVersions.reduce((latest, current) =>
      new Date(current.updatedAt) > new Date(latest.updatedAt) ? current : latest
    );
  }

  const verifiedVersions = snippet.versions.filter(
    (v) => v.status === SnippetStatus.VERIFIED
  );

  if (verifiedVersions.length > 0) {
    return verifiedVersions.reduce((latest, current) =>
      new Date(current.updatedAt) > new Date(latest.updatedAt) ? current : latest
    );
  }

  return snippet.versions.reduce((latest, current) =>
    new Date(current.updatedAt) > new Date(latest.updatedAt) ? current : latest
  );
}
